import _ from 'underscore';

import {
  MAX_CONVERSIONS,
} from './max-conversions';
import { BID_STRATEGY_SCHEMA_MAP } from './bid-strategy-options-map';

export const getBidStrategySchema = (options, bidRange) => {
  const properties = _.reduce(options, (acc, option) => {
    const schemaProperty = BID_STRATEGY_SCHEMA_MAP[option.type];

    // Update bid range (if any) for target CPA instead of using default range.
    // We are re-using the same logic for target CPA and max conversions from legacy bid strategy.
    // https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsCampaignUI?path=/private/campaign-legacy/packages/bidding-strategy/viewmodel/setting.js&version=GBmaster&line=68&lineEnd=72&lineStartColumn=1&lineEndColumn=1&lineStyle=plain&_a=contents
    if (schemaProperty && option.type === MAX_CONVERSIONS.type && bidRange) {
      schemaProperty.properties[MAX_CONVERSIONS.marketingMetric].minimum = bidRange.FloorValue;
      schemaProperty.properties[MAX_CONVERSIONS.marketingMetric].maximum = bidRange.CeilingValue * 4;
    }

    return !schemaProperty ? acc : {
      ...acc,
      ...schemaProperty.properties,
    };
  }, {});

  return {
    name: 'Product Schema',
    type: 'object',
    properties,
  };
};
